// src/utils/auth.js
export const getAuthHeaders = (isForm = false) => {
  const token = localStorage.getItem("authToken");
  const headers = {};

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  // Only add Content-Type automatically for JSON requests.
  // For FormData (isForm === true) do NOT set Content-Type so browser will add boundary.
  if (!isForm) {
    headers["Content-Type"] = "application/json";
  }

  return headers;
};

export const isAuthenticated = () => !!localStorage.getItem("authToken");
export const getToken = () => localStorage.getItem("authToken");

export const clearAuth = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("option");
  localStorage.removeItem("optionValue");
  localStorage.removeItem("activeCat");
  localStorage.removeItem("postStatus");
};
